import { getTableDefinitionStore } from '@/tableDefinitionEditor/store.utilities';
import { setDoTableReload } from '@/tableDefinitionEditor/tableDefinition.actions';
import type { GridApi } from 'ag-grid-community';
import type { EditorType } from '@/tableDefinitionEditor/tableDefinition.types';

function isRowGroupColumn(api: GridApi, columnId: string): boolean {
  return api.getRowGroupColumns().some((col) => col.getColId() === columnId || col.getColDef().field === columnId);
}

/** Soft-reload via doTableReload, or purge SSRM when any column is a row-group level. */
export function requestTableReloadAfterOverride(editorType: EditorType, columnIds: string | string[]): void {
  const api = getTableDefinitionStore(editorType).agGridApi;
  const ids = Array.isArray(columnIds) ? columnIds : [columnIds];
  const isSsrm = api?.getGridOption('rowModelType') === 'serverSide';
  if (api && !api.isDestroyed() && isSsrm && ids.some((id) => isRowGroupColumn(api, id))) {
    api.refreshServerSide({ purge: true });
    return;
  }
  setDoTableReload(editorType, true);
}
